import { LockTooltip } from "../common/LockTooltip";
import React from 'react';

export const AccessHelper = {
    /**
     * @param {string} label - The label to display (children)
     * @param {boolean} isLocked - If the field is locked (by subscription)
     * @param {ReactNode} icon - The icon to display (beside label)
     * @param {string} overrideTitle - The title to display in the tooltip (if locked)
     * @param {string} hoverPopupBehavior - The behavior of the "Not in Subscription" tooltip (entireDiv | lockIconOnly)
     */
    getFormLabel: (label, isLocked, icon, overrideTitle, hoverPopupBehavior = 'entireDiv') => (isLocked ?
        <LockTooltip
            withIcon
            title={overrideTitle}
            hoverPopupBehavior={hoverPopupBehavior}
        >
            {label}
        </LockTooltip> : (
            <span className="subscription-lock-wrapper">
                {label}
                {icon ? (
                    <>
                        &nbsp;
                        {icon}
                    </>
                ) : null}
            </span>
        )),
};
